// Импорт икон из их собственных файлов, а НЕ из барреля '../../components'.
// Через барель получался цикл: core/index -> core/constants -> components/index
// -> компонент -> core/index. Пока всё лежало в одном бандле, порядок
// инициализации случайно складывался рабочим; после разбиения на чанки порядок
// изменился, и константы стали undefined - белый экран на списке парка.
import CharginIcon from '../../components/icons/chraging-icon'
import HighChargeIcon from '../../components/icons/high-charge-icon'
import LowChargeIcon from '../../components/icons/low-charge-icon'
import MediumChargeIcon from '../../components/icons/medium-charge-icon'
import NoBatteryIcon from '../../components/icons/no-battery-icon'

export const unitStatuses = ['READY', 'RENTED', 'IN_INSTALLMENTS', 'OUT', 'OUT_OF_ORDER', 'SERVICE'];
export const SubscriptionFilters = ['R', 'I', 'M'];
// M (Minutely) уже исключена из создания тарифов на бэке (rates.py) -
// показывать её как вариант при заведении нового байка только вводит в
// заблуждение. Фильтр по существующим байкам (SubscriptionFilters выше)
// её не трогает - старые M-байки не должны пропасть из списка.
export const CreatableSubscriptionTypes = ['R', 'I'];
export const FleetFilters = {
  'subscription_type': SubscriptionFilters,
  'status': unitStatuses,
}

export const colorForFilters = {
  subscription_type: {
    R: '#79BCF6',
    I: '#75CC9E',
    M: '#F6A351',
  },
  status: {
    READY: '#79BCF6',
    RENTED: '#75CC9E',
    IN_INSTALLMENTS: '#F6A351',
    OUT: '#CFFFAE',
    OUT_OF_ORDER: '#F49090', 
    SERVICE: '#ABA2FB',
  },
  online_status: {
    online: '#75CC9E',
    offline: '#F49090',
    no_gps: '#F6A351',
  },
  rent_status: {
    '100': '#79BCF6',
    '200': '#F6A351',
    '300': '#75CC9E',
    '400': '#FEB872',
    '500': '#ABA2FB',
    '900': '#F49090',
  }
}

export const fieldByFilterBy = {
  subscription_type: 'subscription_type',
  status: 'status',
}

export const colorsForCharge = {
  LOW: '#C53434',
  MEDIUM: '#F59638',
  HIGH: '#1D7C4D',
  CHARGING: '#2563EB',
  MISSING: 'grey'
}

export const chargeStatuses = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CHARGING: 'CHARGING',
  MISSING: 'MISSING'
}

export const ChargeIconByCharge = {
  LOW: <LowChargeIcon/>,
  MEDIUM: <MediumChargeIcon/>,
  HIGH: <HighChargeIcon/>,
  CHARGING: <CharginIcon/>,
  MISSING: <NoBatteryIcon/>,
}

